module.exports = __webpack_public_path__ + "static/media/intro.1986a107.mp3";